import { Component, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { BreakpointObserver } from '@angular/cdk/layout';
import { StepperOrientation } from '@angular/material/stepper';
import { Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { CreateKaizen, PostResponse, GetResponse } from '../models/Kaizen';
import { KaizenSource } from '../models/KaizenSource';
import { KaizenService } from '../Services/Kaizen.Service';
import { KaizenSourceService } from '../Services/KaizenSource.Services';
import { ConfirmdialogService } from '../Services/confirm-dialog.service';
import { AppComponent } from '../app.component';
import { AttachmentService } from '../Services/Attachment.Service';
import { Attachment } from '../models/Attachment';
import { ProjectType } from '../models/ProjectType';
import { ProjectTypeService } from '../Services/ProjectType.Service';
import { LoaderService } from '../loader/loader.service';
import { DialogaccountdeleteService } from '../Services/dialogaccountdelete.service';
import { MatDialog} from '@angular/material/dialog';
import { DialogDeleteAccountWithActualsConfirmComponent } from '../dialogdeleteaccountwithactualsconfirm/dialogdeleteaccountwithactualsconfirm.component';
import { CurrencyService } from '../Services/Currency.Service';
import { Currency } from '../models/Currency';
import { Location } from '@angular/common';
import { AccountstabComponent } from '../accountstab/accountstab.component';
import { firstValueFrom } from 'rxjs';
@Component({
    selector: 'app-add-edit-kaizen',
    templateUrl: './add-edit-kaizen.component.html',
    styleUrls: ['./add-edit-kaizen.component.css'],
    standalone: false
})
export class AddEditKaizenComponent {
  @ViewChild(AccountstabComponent) acTabComponent!: AccountstabComponent;
  @ViewChild('stepper') private stepper: any;
  public submitOrMoveAction!: boolean;
  public reApprovalReq: boolean = false;
  kaizenSourcesLoaded!: boolean;
  currenciesLoaded !: boolean;
  projectTypesLoaded !: boolean;
  investmentTypesLoaded !: boolean;
  milestonesImplementedLoaded !: boolean;
  fundamentalAlert: boolean = true;
  estimatedMonth!: number;
  currencies !: Currency[];
  rankTabInvalid: boolean = true;
  contactTabValid: boolean = true;
  locationTabValid: boolean = false;
  ringiTabInvalid: boolean = false;
  yokotenTabValid: boolean = true;
  descriptionTabInvalid: boolean = true;
  kaizenSources!: KaizenSource[];
  kaizenAttachments !: Attachment[];
  projectTypes !: ProjectType[];
  startDate!: Date;
  isCostConfirmed: boolean = false;
  isPendingRevision: boolean = false;
  isInProgress: boolean = false;
  isSubmitted: boolean = false;
  isCancelled: boolean = false;
  isRingiChecked: boolean = false;
  isyokotenFromOtherShop: boolean = false;
  haveBpaksID: boolean = false;
  isApplicableForSpecificShop: boolean = false;
  isApplicableAccrossOtherShops: boolean = false;
  isLoading: boolean = false;
  hasRecords: boolean = false;
  model: any = {};
  isLinear = false;
  kaizenId: number = 0;
  editKaizenId: number = 0;
  reloadKaizenId: number = 0 ;
  kaizenStatus: string = "";
  supportingMembers: string[] = [];
  Response: PostResponse = new PostResponse();
  kaizenCreatedDate!: Date;
  colHeaders = ['Jan-22', 'Feb-22', 'Mar-22', 'Apr-22', 'May-22', 'Jun-22', 'Jul-22', 'Aug-22', 'Sep-22', 'Oct-22', 'Nov-22', 'Dec-22', 'Total'];
  months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  maxFileSize: number = 6291456  //This is 6MB since 1,048,576 is 1MB 
  supportedUploadFileTypes = [
    'xls', 'xlsm', 'xlsx',
    'doc', 'docm', 'docx',
    'txt',
    'png', 'jpg', 'gif', 'jpeg',
    'pdf',
    'ppt', 'pptx', 'pptm'

  ];
  extension: string = '';
  errorFileTypeNotSupported: boolean = false;
  errorFileTooLarge: boolean = false;
  errorFileLimit: boolean = false;
  ParamNames: string[] = [];
  ParamValues: string[] = [];
  monHeaders: string[] = [];
  GetResponse: GetResponse = new GetResponse();
  CreateKaizen: CreateKaizen = new CreateKaizen();
  firstFormGroup!: UntypedFormGroup;
  secondFormGroup!: UntypedFormGroup;
  stepperOrientation: Observable<StepperOrientation>;
  options = [];
  requiredLegend: string = '* = required field';
  timeZoneAbbreviation = new Date().toLocaleTimeString('en-us', { timeZoneName: 'short' }).split(' ')[2];
  costConfirmedDisplayDate: string = "";
  modifiedDisplayDate: string = "";
  createdDisplayDate: string = "";
  pendingRevisionDisplayDate: string = "";
  progressChangedDisplayDate: string = "";
  kaizenStatusDisplayString: string = "";
  fileSelectionBoxLabel: string = "Choose file...";
  draftStatusWithNoAccounts: boolean = false;
  firstFormValid: boolean = true;
  fifthFormValid: boolean = true;
  showNextButton:boolean = true;
  get companyID() {
    return this.CreateKaizen.companyID;
  }
  public formToSave: number | undefined;
  isAdmin: boolean = false;

  constructor(private route: ActivatedRoute, breakpointObserver: BreakpointObserver,
    private KaizenService: KaizenService, private KaizenSourceService: KaizenSourceService,
    private router: Router, private confirmdialogservice: ConfirmdialogService,
    private AttachmentService: AttachmentService,
    private ProjectTypeService: ProjectTypeService,
    public loaderService: LoaderService,
    private dialogAccountDeleteService: DialogaccountdeleteService,
    private appComp: AppComponent,
    private location : Location
    ) {
    this.stepperOrientation = breakpointObserver
      .observe('(min-width: 800px)')
      .pipe(map(({ matches }) => (matches ? 'horizontal' : 'vertical')));
  }
  ngOnInit() {
    const role = localStorage.getItem(`adroleNormalized`);
    if (role != `Submitter` && role != `SystemAdmin` && role != `ISAdmin` && role != `CMDApproverPlus`) {
      this.router.navigate([`./kaizens`]);
    }
    this.isAdmin =(role == `SystemAdmin` || role == `ISAdmin`);

    this.editKaizenId = Number(this.route.snapshot.paramMap.get('id'));
    this.getProjectTypes();
    if (this.editKaizenId == 0) {
      //set the id to 1 which is draft since it is a new Kaizen
      this.CreateKaizen.kaizenStateID = 1;
      this.draftStatusWithNoAccounts = true;
      this.CreateKaizen.kaizenTypeID = 1;
    }
    else {
      this.initLoadExistingKaizen();
      this.fileSelectionBoxLabel = "Choose file...";
    }
    if (this.editKaizenId == 0) {
      this.fileSelectionBoxLabel = "Kaizen must be saved before adding attachments";
    }
  }
  async initLoadExistingKaizen() {
    //since we cannot save a kaizen without valid information on the description tab we set the value here
    //this.descriptionTabInvalid = false;
    await this.getKaizen(this.editKaizenId);    
  
  }
  saveForm(formNumber: number): void {
    if(formNumber == 10){
      this.showNextButton = false;
    }
    this.submitOrMoveAction = true;
    this.formToSave = formNumber;
    this.onSubmit();
  }
  onSubmit(): void {
    this.CreateKaizen.kaizenTypeID = 1;
    if (this.CreateKaizen.ringiNumber == null) {
      this.CreateKaizen.ringiNumber = '';
    }
    if (this.CreateKaizen.investmentAmount == null) {
      this.CreateKaizen.investmentAmount = 0;
    }
    if (this.CreateKaizen.title == null) {
      this.CreateKaizen.title = '';
    }
    if (this.CreateKaizen.description == null) {
      this.CreateKaizen.description = '';
    }
    if (this.formToSave == 5) {
      if (this.isCostConfirmed) {
   if(this.CreateKaizen.currencyID.toString() =='')
      {
        this.CreateKaizen.currencyID = 1;
      }
        this.CreateKaizen.kaizenStateID = 6;
        this.CreateKaizen.progressChangedBy = this.appComp.ademail;
        this.CreateKaizen.progressChangedOn = new Date().toISOString();
      }
      else {
        this.CreateKaizen.kaizenStateID = 2;
        this.CreateKaizen.SubmittedBy = localStorage.getItem('ademail')!;
        this.CreateKaizen.SubmittedOn = new Date();
      }
    }
    else if (this.formToSave == 55) {
      this.CreateKaizen.kaizenStateID = 1;
    }
    console.log('Posting values', this.CreateKaizen);
    if (this.editKaizenId == 0) {
      this.CreateKaizen.createdBy = this.appComp.ademail;
      this.CreateKaizen.createdOn = new Date().toISOString();
      this.KaizenService.addKaizen(this.CreateKaizen).subscribe(
        (data) => {
          if (data && data.data) {
            this.kaizenId = data.data.kaizenId;
            this.editKaizenId = data.data.kaizenId;
            this.kaizenCreatedDate = data.data.createdAt;
            this.CreateKaizen.kaizenNumber = data.data.kaizenNumber;
      
            if (this.formToSave == 10) { // next button from first tab
              this.reloadKaizenId = this.editKaizenId;
              this.initLoadExistingKaizen();
              const loc = this.location.path();
              this.location.replaceState(`${loc}/${this.kaizenId}`);
              this.stepper.selectedIndex = 1;
            }
          } else {
            console.warn('No data received or data is incomplete');
            // Handle the case where data is undefined or incomplete
          }
        },
        (error) => {
          console.error('Error adding Kaizen:', error);
          // Handle the error appropriately
        }
      );
      
    }
    else if (this.editKaizenId != 0) {
      this.CreateKaizen.modifiedBy = this.appComp.ademail;
      this.CreateKaizen.modifiedOn = new Date().toISOString();
      //If this is modifying an costConfirmed Kaizen then make a copy and save the changes in the copy leaving the original posted Kaizen untouched
      //but only for the fields which require reapproval.  The other fields can be changed without versioning.Since we have complete information
      //for the Kaizen, we can just call the addKaizen after changing the version and state values
      if (this.isCostConfirmed && this.reApprovalReq) {
        this.CreateKaizen.version++;
        //Set the Creation date since we will be creating a new Kaizen.
        this.CreateKaizen.createdOn = new Date().toISOString();
        if (this.formToSave == null) {
          this.CreateKaizen.kaizenStateID = 2
        }
        else if (this.isCostConfirmed) {
          this.CreateKaizen.kaizenStateID = 2
          this.CreateKaizen.SubmittedBy = localStorage.getItem('ademail')!;
          this.CreateKaizen.SubmittedOn = new Date();
        }
        else {
          this.CreateKaizen.kaizenStateID = 1
        }
        var response = this.KaizenService.addKaizen(this.CreateKaizen).subscribe({
          next: data => {
            this.kaizenId = data.data.kaizenId;
            this.kaizenCreatedDate = data.data.createdAt;
            this.CreateKaizen.kaizenNumber = data.data.kaizenNumber;
          },
          error: error => { console.log('There was an error!', error); }
        });
      }
      //Update the current Kaizen
      else {
        if (this.formToSave == 6) {
          this.CreateKaizen.kaizenStateID = 2;
        }
        var response = this.KaizenService.updateKaizen(this.CreateKaizen).subscribe({
          next: data => { this.kaizenId = data.data.kaizenId; this.kaizenCreatedDate = data.data.createdAt },
          error: error => { console.log('There was an error!', error); }
        });
      }
    }
    if (this.formToSave != null) {
      if (this.formToSave != 10) { 
        this.stepper.selectedIndex = 5;
        }
    }
  };
  cancel() {
    this.confirmdialogservice.openDialog().afterClosed().subscribe(res => {
      if (res) {
        this.router.navigate(['./kaizens']);
      }
    });
  }
  //getProjectTypes(): void { this.ProjectTypeService.getProjectTypes().subscrsibe(data => this.projectTypes = data.data, error => console.log(error), () => this.projectTypesLoaded = true); }
  getProjectTypes(): void {
    this.ProjectTypeService.getProjectTypes().subscribe({
      next: data => {
        this.projectTypes = data.data;
        this.projectTypesLoaded = true;
      },
      error: error => console.log(error)
    });
  }
  async getKaizen(id: number): Promise<void> {
    this.loaderService.isLoading.next(true);

    try {
      const data = await firstValueFrom(this.KaizenService.getKaizen(id));
      this.CreateKaizen = data?.data ?? new CreateKaizen();

      if (this.CreateKaizen.kaizenStateID == 4) {
        this.isCostConfirmed = true;
      } else {
        this.isCostConfirmed = false;
      }

      if (!this.CreateKaizen.estimatedImplementationYear || this.CreateKaizen.estimatedImplementationYear == '0') {
        this.draftStatusWithNoAccounts = true;
      }

      this.estimatedMonth = Number(this.CreateKaizen.estimatedImplementationMonth);

      // Dates are in UTC timezone, so convert dates to local time zone
      this.createdDisplayDate = new Date(this.CreateKaizen.createdOn + "Z").toLocaleString();
      this.costConfirmedDisplayDate = new Date(this.CreateKaizen.costConfirmedOn + "Z").toLocaleString();
      this.pendingRevisionDisplayDate = new Date(this.CreateKaizen.pendingRevisionOn + "Z").toLocaleString();
      this.progressChangedDisplayDate = new Date(this.CreateKaizen.progressChangedOn + "Z").toLocaleString();

      // If not modified show createdOn as last modified date otherwise show modifiedOn date
      this.modifiedDisplayDate =
        new Date(this.CreateKaizen.modifiedOn + "Z").toDateString() == "Sun Dec 31 0000"
          ? this.createdDisplayDate
          : new Date(this.CreateKaizen.modifiedOn + "Z").toLocaleString();

      // Decode the status and set flags and string for display in html
      switch (this.CreateKaizen.kaizenStateID) {
        case 2:
          this.isSubmitted = true;
          this.kaizenStatusDisplayString = 'Submitted';
          this.reApprovalReq = false;
          break;

        case 3:
          this.isPendingRevision = true;
          this.kaizenStatusDisplayString = 'Pending Revision';
          this.reApprovalReq = false;
          break;

        case 4:
          this.isCostConfirmed = true;
          this.kaizenStatusDisplayString = 'Cost Confirmed';
          this.reApprovalReq = false;
          break;

        case 6:
          this.isInProgress = true;
          this.kaizenStatusDisplayString = 'In progress';
          break;

        case 9:
          this.isCancelled = true;
          this.kaizenStatusDisplayString = 'Cancelled';
          this.reApprovalReq = false;
          break;
      }

      // If the description and titles are populated then description is valid
      if (
        this.CreateKaizen.description.length > 0 && this.CreateKaizen.description.length < 2001 &&
        this.CreateKaizen.title.length > 0 && this.CreateKaizen.title.length < 201
      ) {
        this.descriptionTabInvalid = false;
      } else {
        this.descriptionTabInvalid = true;
      }

      this.getKaizenSourcesForEdit();
      this.getAttachments();
      this.setValues();
    } catch (error) {
      console.error(error);
    } finally {
      this.loaderService.isLoading.next(false);
    }
  }
  getAccountsTab(ckAccounts: CreateKaizen) {
    
    if(!this.CreateKaizen.estimatedImplementationYear || this.CreateKaizen.estimatedImplementationYear == '0')
    {
      this.draftStatusWithNoAccounts = true;
    }
    else
    {
      this.draftStatusWithNoAccounts = false;
    }
    if (ckAccounts.estimatedImplementationYear && ckAccounts.estimatedImplementationMonth && ckAccounts.estimatedImplementationDay)
    {
      this.CreateKaizen.estimatedImplementationMonth = ckAccounts.estimatedImplementationMonth;
      this.CreateKaizen.estimatedImplementationDay = ckAccounts.estimatedImplementationDay;
      this.CreateKaizen.estimatedImplementationYear = ckAccounts.estimatedImplementationYear;
    }
    
    this.CreateKaizen.KaizenAccount = ckAccounts.KaizenAccount;
    this.reApprovalReq = ckAccounts.reApprovalReq;
    this.fifthFormValid = ckAccounts.fifthFormValid;
  }
  getYokotenTab(ckYokoten: CreateKaizen) {
    this.CreateKaizen.isYokoyenFromAnotherShop = ckYokoten.isYokoyenFromAnotherShop;
    this.CreateKaizen.haveBpaksID = ckYokoten.haveBpaksID;
    this.CreateKaizen.kaizenSourceIdentifier = ckYokoten.kaizenSourceIdentifier;
    if (ckYokoten.kaizenSourceID != undefined && ckYokoten.kaizenSourceID != 0) 
    {
      this.CreateKaizen.kaizenSourceID = ckYokoten.kaizenSourceID;
    }
    this.CreateKaizen.kaizenSourceDescription = ckYokoten.kaizenSourceDescription;
    this.CreateKaizen.additionalKaizenSourceDescription = ckYokoten.additionalKaizenSourceDescription;
    this.CreateKaizen.applicableToAllShops = ckYokoten.applicableToAllShops;
    this.CreateKaizen.applicableToSpecificShops = ckYokoten.applicableToSpecificShops;
    this.CreateKaizen.applicableForOtherShopOrPlants = ckYokoten.applicableForOtherShopOrPlants;
    this.CreateKaizen.kaizenTags = ckYokoten.kaizenTags;
    if (this.CreateKaizen.isYokoyenFromAnotherShop) 
    {
      if (this.CreateKaizen.haveBpaksID) 
      {
        this.yokotenTabValid = (this.CreateKaizen.kaizenSourceIdentifier != "" && this.CreateKaizen.kaizenSourceIdentifier != undefined);
      }
      else 
      {
        this.yokotenTabValid = (this.CreateKaizen.kaizenSourceID != 0 && this.CreateKaizen.kaizenSourceID != undefined);
      }     
    }
    else if (ckYokoten.applicableForOtherShopOrPlants)
    {
      this.yokotenTabValid = (this.CreateKaizen.applicableToSpecificShops || this.CreateKaizen.applicableToAllShops);     
    }
    else 
    {
      
      this.yokotenTabValid = true;
    }
  }
  getRankTab(cKRank: CreateKaizen) {
    this.CreateKaizen.projectTypeID = cKRank.projectTypeID;
    this.CreateKaizen.investmentTypeID = cKRank.investmentTypeID;
    this.CreateKaizen.rankID = cKRank.rankID;
    this.CreateKaizen.rankDecisionTiming = cKRank.rankDecisionTiming;
    this.CreateKaizen.rankDifficultyID = cKRank.rankDifficultyID;
    this.CreateKaizen.rankChangeDescription = cKRank.rankChangeDescription;
    this.CreateKaizen.milestoneImplementedID = cKRank.milestoneImplementedID;
    if (cKRank.investmentTypeID != null) {
      if (cKRank.investmentTypeID.toString() != '') {
        this.rankTabInvalid = false;
      }
      else {
        this.rankTabInvalid = true;
      }
    }
  }

  getContactTab(setContact: CreateKaizen) {
    this.CreateKaizen.kaizenCreator = setContact.kaizenCreator;
    this.CreateKaizen.kaizenLeader = setContact.kaizenLeader;
    this.CreateKaizen.kaizenSupportingPerson = setContact.kaizenSupportingPerson;
    if (this.CreateKaizen.kaizenCreator == undefined || this.CreateKaizen.kaizenLeader == undefined) {
      this.contactTabValid = false;
    }
    else {
      if (this.CreateKaizen.kaizenCreator == '' || this.CreateKaizen.kaizenLeader == '' || setContact.kaizenCreatorValid == false || setContact.kaizenLeaderValid == false) {
        this.contactTabValid = false;
      }
      else {
        this.contactTabValid = true;
      }
    }
    if (this.contactTabValid && this.locationTabValid) {
      this.firstFormValid = true;
    }
    else {
      this.firstFormValid = false;
    }    
  }
  getLocationTab(setLocation: CreateKaizen) {
    this.CreateKaizen.companyName = setLocation.companyName;
    this.CreateKaizen.lineName = setLocation.lineName;
    this.CreateKaizen.shopName = setLocation.shopName;
    this.CreateKaizen.vehicleModel = setLocation.vehicleModel;
    this.CreateKaizen.impactingModel = setLocation.impactingModel;
    if (this.editKaizenId != 0) {
      if (setLocation.companyID != undefined && this.CreateKaizen.companyID != setLocation.companyID) {
        this.reApprovalReq = true;
        if (this.fundamentalAlert) {
          this.destroyAllAccounts();
          this.fundamentalAlert = false;
        }
      }
      else {
        this.reApprovalReq = false;
      }
      if (setLocation.lineID != undefined && this.CreateKaizen.lineID != setLocation.lineID) {
        this.reApprovalReq = true;
        if (this.fundamentalAlert) {
          this.destroyAllAccounts();
          this.fundamentalAlert = false;
        }
      }
      else {
        this.reApprovalReq = false;
      }
      if (setLocation.shopID != undefined && this.CreateKaizen.shopID != setLocation.shopID) {
        this.reApprovalReq = true;
        if (this.fundamentalAlert) {
          this.destroyAllAccounts();
          this.fundamentalAlert = false;
        }
      }
      else {
        this.reApprovalReq = false;
      }
      if (setLocation.vehicleModelID != undefined && this.CreateKaizen.vehicleModelID != setLocation.vehicleModelID) {
        this.reApprovalReq = true;
        if (this.fundamentalAlert) {
          this.destroyAllAccounts();
          this.fundamentalAlert = false;
        }
      }
      else {
        this.reApprovalReq = false;
      }
      if (setLocation.kaizenImpactingModelID != undefined && this.CreateKaizen.kaizenImpactingModelID != setLocation.kaizenImpactingModelID) {
        this.reApprovalReq = true;
        if (this.fundamentalAlert) {
          this.destroyAllAccounts();
          this.fundamentalAlert = false;
        }
      }
      else {
        this.reApprovalReq = false;
      }
    }
    if (this.ParamNames.indexOf('Company') == -1) {
      this.ParamNames.push('Company');
      this.ParamValues.push(this.CreateKaizen.companyName);
    }
    else {
      this.ParamValues[this.ParamNames.indexOf('Company')] = this.CreateKaizen.companyName;
    }
    if (this.ParamNames.indexOf('Line') == -1) {
      this.ParamNames.push('Line');
      this.ParamValues.push(this.CreateKaizen.lineName);
    }
    else {
      this.ParamValues[this.ParamNames.indexOf('Line')] = this.CreateKaizen.lineName;
    }
    if (this.ParamNames.indexOf('Shop') == -1) {
      this.ParamNames.push('Shop');
      this.ParamValues.push(this.CreateKaizen.shopName);
    }
    else {
      this.ParamValues[this.ParamNames.indexOf('Shop')] = this.CreateKaizen.shopName;
    }
    if (this.ParamNames.indexOf('Model') == -1) {
      this.ParamNames.push('Model');
      this.ParamValues.push(this.CreateKaizen.vehicleModel == 'undefined' || this.CreateKaizen.vehicleModel == ''|| this.CreateKaizen.vehicleModel == null ? 'Not Selected' : this.CreateKaizen.vehicleModel);
    }
    else {
      this.ParamValues[this.ParamNames.indexOf('Model')] = this.CreateKaizen.vehicleModel == 'undefined' || this.CreateKaizen.vehicleModel == '' || this.CreateKaizen.vehicleModel == null ? 'Not Selected' : this.CreateKaizen.vehicleModel;
    }
    if (this.ParamNames.indexOf('Selected Savings Impact') == -1) {
      this.ParamNames.push('Selected Savings Impact');
      this.ParamValues.push(this.CreateKaizen.impactingModel);
    }
    else {
      this.ParamValues[this.ParamNames.indexOf('Selected Savings Impact')] = this.CreateKaizen.impactingModel;
    }
    this.CreateKaizen.companyID = setLocation.companyID;
    this.CreateKaizen.shopID = setLocation.shopID;
    this.CreateKaizen.lineID = setLocation.lineID;
    this.CreateKaizen.costCenterID = setLocation.costCenterID;
    this.CreateKaizen.costCenterName = setLocation.costCenterName;
    this.CreateKaizen.vehicleModelID = setLocation.vehicleModelID;
    this.CreateKaizen.kaizenImpactingModelID = setLocation.kaizenImpactingModelID;
    this.CreateKaizen.supportingCompanyID = setLocation.supportingCompanyID;
    this.CreateKaizen.supportingLineID = setLocation.supportingLineID;
    this.CreateKaizen.supportingShopID = setLocation.supportingShopID;
    this.CreateKaizen.supportingCostCenterID = setLocation.supportingCostCenterID;
    if (this.CreateKaizen.companyID == undefined || this.CreateKaizen.lineID == undefined || this.CreateKaizen.shopID == undefined || this.CreateKaizen.kaizenImpactingModelID == undefined) {
      this.locationTabValid = false;
    }
    else {
      if (this.CreateKaizen.companyID.toString() == '' || this.CreateKaizen.lineID.toString() == '' || this.CreateKaizen.shopID.toString() == ''
        || this.CreateKaizen.kaizenImpactingModelID.toString() == '' || this.CreateKaizen.lineID == 0 || this.CreateKaizen.shopID == 0
        || (this.CreateKaizen.kaizenImpactingModelID == 4 && this.CreateKaizen.vehicleModel == undefined)
      ) {
        this.locationTabValid = false;
      }
      else {
        this.locationTabValid = true;
      }
    }
    if (this.locationTabValid && this.contactTabValid) {
      this.firstFormValid = true;
    }
    else {
      this.firstFormValid = false;
    }
  }

  getRingiTab(setRingiInformation: any) {
    if (setRingiInformation.CreateKaizen.ringiNumber != undefined) {
      this.CreateKaizen.ringiNumber = setRingiInformation.CreateKaizen.ringiNumber;
    }
    if (setRingiInformation.CreateKaizen.investmentAmount != undefined) {
      this.CreateKaizen.investmentAmount = setRingiInformation.CreateKaizen.investmentAmount;
    }
    if(setRingiInformation.CreateKaizen.currencyID !=undefined)
    {
      this.CreateKaizen.currencyID = setRingiInformation.CreateKaizen.currencyID
    }
    this.ringiTabInvalid = !setRingiInformation.isValid;
  }
  getDescriptionTab(setDescriptionInformation: any) {
    if (setDescriptionInformation.isValid == true) {
      this.CreateKaizen.title = setDescriptionInformation.CreateKaizen.title;
      this.CreateKaizen.description = setDescriptionInformation.CreateKaizen.description;
      this.CreateKaizen.includeCostInObeya = setDescriptionInformation.CreateKaizen.includeCostInObeya;
      this.CreateKaizen.isBOD = setDescriptionInformation.CreateKaizen.isBOD;
      this.CreateKaizen.internalTrackingNo = setDescriptionInformation.CreateKaizen.internalTrackingNo;
      this.CreateKaizen.trackingRef1 = setDescriptionInformation.CreateKaizen.trackingRef1;
      this.CreateKaizen.trackingRef2 = setDescriptionInformation.CreateKaizen.trackingRef2;
      this.CreateKaizen.additionalComments = setDescriptionInformation.CreateKaizen.additionalComments;//.length > 0 ? setDescriptionInformation.additionalComments : '';
    }
    this.descriptionTabInvalid = !setDescriptionInformation.isValid;
  }
  // #endregion
  //getKaizenSources(): void { this.KaizenSourceService.getKaizenSources().subwscribe(data => this.kaizenSources = data.data, error => console.log(error), () => this.kaizenSourcesLoaded = true); }
  getKaizenSources(): void {
    this.KaizenSourceService.getKaizenSources().subscribe({
      next: data => {
        this.kaizenSources = data.data;
        this.kaizenSourcesLoaded = true;
      },
      error: error => console.log(error)
      
    });
  }
  getKaizenSourcesForEdit(): void {
    firstValueFrom(this.KaizenSourceService.getKaizenSources()).then((data) => {
      this.kaizenSources = data?.data || [] ;
      if (this.CreateKaizen.kaizenSourceID != null) {
        this.secondFormGroup.controls['kaizenSourceId'].setValue(this.CreateKaizen.kaizenSourceID);
      }
    }, (error) => {
    })
  };
  getAttachments(): void {
    firstValueFrom(this.AttachmentService.getAttachmentsByKaizenId(this.editKaizenId)).then((data) => {
      this.kaizenAttachments = data?.data || [] ;
      //console.log(this.kaizenAttachments);
    })
  }

  setValues(): void {
    if (this.CreateKaizen.kaizenStateID == 1) { this.kaizenStatus = 'Draft' }
    else if (this.CreateKaizen.kaizenStateID == 2) { this.kaizenStatus = 'Submitted' }
    else if (this.CreateKaizen.kaizenStateID == 3) { this.kaizenStatus = 'Pending Revision' }
    else if (this.CreateKaizen.kaizenStateID == 4) { this.kaizenStatus = 'Cost Confirmed' }
    else if (this.CreateKaizen.kaizenStateID == 5) { this.kaizenStatus = 'Closed' }
    else if (this.CreateKaizen.kaizenStateID == 6) { this.kaizenStatus = 'In progress' }
    else if (this.CreateKaizen.kaizenStateID == 7) { this.kaizenStatus = 'Approaching' }
    else if (this.CreateKaizen.kaizenStateID == 8) { this.kaizenStatus = 'Behind' }
    else if (this.CreateKaizen.kaizenStateID == 9) { this.kaizenStatus = 'Cancelled' }
    else if (this.CreateKaizen.kaizenStateID == 10) { this.kaizenStatus = 'Complete' }
  }
  move(index: number) {
    this.submitOrMoveAction = true;
    if (index == 1) {
      if (this.contactTabValid && this.locationTabValid) {
        this.firstFormValid = true;
      }
      else {
        this.firstFormValid = false;
      }

      if (this.firstFormValid)
        this.stepper.selectedIndex = index;
    }
    else if (index == 2) {
      var secondFormValid: boolean = true;
      if (this.CreateKaizen.isYokoyenFromAnotherShop) 
      {
        if (this.CreateKaizen.haveBpaksID) {
          secondFormValid = secondFormValid && (this.CreateKaizen.kaizenSourceIdentifier != "" || this.CreateKaizen.kaizenSourceIdentifier != undefined);
        }
        else {
          secondFormValid = secondFormValid && (this.CreateKaizen.kaizenSourceID != 0);
        }
        if (this.CreateKaizen.applicableForOtherShopOrPlants) {
          secondFormValid = secondFormValid && (this.CreateKaizen.applicableToSpecificShops || this.CreateKaizen.applicableToAllShops);
        }
      }
 
      else{
        secondFormValid = true;
      }
 
      if (secondFormValid)
        this.stepper.selectedIndex = index;
    }
    else if (index == 3) {
      var thirdFormValid: Boolean = true;
      if (thirdFormValid)
        this.stepper.selectedIndex = index;
    }
    else if (index == 4) {
 
      var fourthFormValid: Boolean = true
       
      if (this.rankTabInvalid) {
        fourthFormValid = false;
      }
      else {
        fourthFormValid = true;
      }
      if (fourthFormValid) {
        this.stepper.selectedIndex = index;

        if (this.acTabComponent.selectedDate === '') {
          // new kaizen so need to disable the account controls until a date is selected
          if (this.acTabComponent.accountArray !== null && this.acTabComponent.accountArray !== undefined) {
            if (this.acTabComponent.accountArray.controls !== undefined && this.acTabComponent.accountArray.controls.length > 0) {
              this.acTabComponent.accountArray.controls[0].get('costDirectionID')?.disable();
              this.acTabComponent.accountArray.controls[0].get('costTypeID')?.disable();
              this.acTabComponent.accountArray.controls[0].get('gLAccountImpactAreaID')?.disable();
              this.acTabComponent.accountArray.controls[0].get('detailedAccountId')?.disable();
              this.acTabComponent.accountArray.controls[0].get('savingsMeasureID')?.disable();
            }
          }
        }
      }
    }
    else if (index == 5) {
      var fifthFormValid: Boolean = true;

      if (fifthFormValid)
        this.stepper.selectedIndex = index;

    }

  }
  fileUploadChanged(event: any) {
    var file = event.target.files[0];
    this.fileSelectionBoxLabel = file.name;
    if (file.size > this.maxFileSize) {
      this.errorFileTooLarge = true;
    }
    //This the extension.  If no extension exists then empty string is returned
    var uploadFileExtension = file.name.slice((file.name.lastIndexOf(".") - 1 >>> 0) + 2);
    if (!this.supportedUploadFileTypes.includes(uploadFileExtension)) {
      this.extension = uploadFileExtension;
      this.errorFileTypeNotSupported = true;
    }
    if (this.kaizenAttachments.length > 4) {
      this.errorFileLimit = true;
    }
    if (!this.errorFileTooLarge &&
      !this.errorFileTypeNotSupported &&
      !this.errorFileLimit
    ) {
      this.AttachmentService.uploadFile(file, this.editKaizenId).subscribe({
        next: data => { this.addAttachment(file.name) },
        error: error => { console.log('There was an error!', error); }
      });
    }
  }
  addAttachment(fileName: string) {
    let newAttachment: Attachment =
    {
      kaizenID: this.editKaizenId,
      kaizenAttachmentID: 0,
      attachmentName: fileName,
      attachementPath: '',
      attachmentComments: '',
      isActive: ''
    }
    this.AttachmentService.addAttachment(newAttachment).subscribe({
      next: data => {
        newAttachment.kaizenAttachmentID = data.data;
        this.kaizenAttachments.push(newAttachment);
        this.fileSelectionBoxLabel = "Choose file...";
      },
      error: error => { console.log('There was an error!', error); }
    });
  }
  downloadAttachment(attachmentName: string, kaizenId: number) {
    this.AttachmentService.viewFile(attachmentName, kaizenId).subscribe({
      next: results => {
        window.open(results, '_blank');
      },
      error: error => { console.log('There was an error!', error); }
    });
  }
  DeleteAttachment(attachmentId: number, attachmentName: string) {
    this.AttachmentService.deleteAttachment(attachmentId).subscribe({
      next: data => {
        this.AttachmentService.deleteFile(this.editKaizenId, attachmentName).subscribe({
          next: blobData => { },
          error: error => { console.log('There was an error!', error); }
        })
        //remove the deleted attachment from the array to remove it from the display also
        this.kaizenAttachments.splice(this.kaizenAttachments.findIndex(a => a.kaizenAttachmentID == attachmentId), 1);
      },
      error: error => { console.log('There was an error!', error); }
    });
  }
 
  async destroyAllAccounts(): Promise<boolean> {
    if (!this.draftStatusWithNoAccounts) {
      await firstValueFrom(this.dialogAccountDeleteService.openDialog().afterClosed()).then(
        (res) => {
          if (res) {
            this.callChildFunction();
            this.fundamentalAlert = false;
          }
          else {
            this.fundamentalAlert = false;
          }
        });

    }
    return this.fundamentalAlert;
  }
  
  callChildFunction(): void {
    this.acTabComponent.delAllAC();
  }

  onRecalc(e: any)
  {
    //call into function in child component
     this.acTabComponent.Recalc();
  }
}